// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The token for the kernels service.
 */
export const IKernels = new Token('@jupyterlite/kernel:IKernels');
/**
 * The kernel name of last resort.
 */
export const FALLBACK_KERNEL = 'javascript';
/**
 * The token for the kernel spec service.
 */
export const IKernelSpecs = new Token('@jupyterlite/kernel:IKernelSpecs');
//# sourceMappingURL=tokens.js.map